module.exports = __webpack_public_path__ + "hatGlasses.svg?8292102fff639d0baf1c39b48a1ea24a";